import { render } from "./ProjectList.vue?vue&type=template&id=40e67ce8&scoped=true&ts=true"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"

import "./ProjectList.vue?vue&type=style&index=0&id=40e67ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e67ce8"]])

export default __exports__